import SectionHeading from '../shared/SectionHeading';
import { TEXT_STYLES, BORDER_STYLES } from '../../constants/styles';

function ProjectReflections({ title = 'Reflections', paragraphs = [] }) {
  if (!paragraphs || paragraphs.length === 0) return null;

  return (
    <div className="max-w-3xl mx-auto space-y-6 mb-16 scroll-mt-32">
      <div className="prose prose-lg">
        {title && <SectionHeading>{title}</SectionHeading>}
        {paragraphs.map((paragraph, index) => {
          // Check if this paragraph is a sub-header (starts with a header key)
          if (typeof paragraph === 'object' && paragraph.header) {
            return (
              <div key={index} className={index < paragraphs.length - 1 ? 'mb-12' : ''}>
                <SectionHeading>{paragraph.header}</SectionHeading>
                <div className={TEXT_STYLES.body}>
                  {paragraph.text.split('\n\n').map((para, idx) => (
                    <p key={idx} className={idx < paragraph.text.split('\n\n').length - 1 ? 'mb-6' : ''}>
                      {para}
                    </p>
                  ))}
                </div>
                {paragraph.image && (
                  <div className="mt-6">
                    <img
                      src={paragraph.image}
                      alt={paragraph.header}
                      className={`w-full h-auto ${BORDER_STYLES.rounded}`}
                    />
                  </div>
                )}
              </div>
            );
          }
          // Regular paragraph
          return (
            <p 
              key={index}
              className={`${TEXT_STYLES.body} ${index < paragraphs.length - 1 ? 'mb-12' : ''}`}
            >
              {paragraph}
            </p>
          );
        })}
      </div>
    </div>
  );
}

export default ProjectReflections;
